import { render } from "./RegexResultsTable.vue?vue&type=template&id=45a2667c"
import script from "./RegexResultsTable.vue?vue&type=script&lang=ts"
export * from "./RegexResultsTable.vue?vue&type=script&lang=ts"
script.render = render

export default script